import { CardHeader } from '../../atoms/card/card-header';
import { CardContent } from '../../atoms/card/card-content';
import { CardDivider } from '../../atoms/card/card-divider';
import { Card } from '../../atoms/card/card';
import { BookingListItemInfo, BookingListItemInfoProps } from './booking-list-item-info';
import { FC } from 'react';
import { BookingListItemProduct, BookingListItemProductProps } from './booking-list-item-product';
import { BookingListItemFooter, BookingListItemFooterProps } from './booking-list-item-footer';

export type BookingLIstItemProps = BookingListItemInfoProps & BookingListItemProductProps & BookingListItemFooterProps & {
  cardTitle: React.ReactElement;
  bookingAction: React.ReactElement;
}

/**
 * This component is used to display a booking list item on the booking list page.
 * It's only a layout wrapper for the booking list item. All the information will be displayed in the subcomponents.
 */
export const BookingListItem: FC<BookingLIstItemProps> = ({
  renterName,
  project,
  price,
  status,
  cardTitle,
  productTypeTitle,
  bookingDateRange,
  rentalStationName,
  amount,
  bookingDetailsUrl,
  translations,
  bookingAction,
  tenantImageUrl,
}) => {
  return (
    <Card>
      <CardHeader title={cardTitle}>
        {bookingAction}
      </CardHeader>

      <CardContent>
        <BookingListItemInfo
          price={price}
          renterName={renterName}
          project={project}
          status={status}
          translations={translations}
        />
      </CardContent>

      <CardDivider />

      <CardContent>
        <BookingListItemProduct
          productTypeTitle={productTypeTitle}
          bookingDateRange={bookingDateRange}
          rentalStationName={rentalStationName}
          amount={amount}
          translations={translations}
        />
      </CardContent>

      <CardDivider />

      <CardContent>
        <BookingListItemFooter
          bookingDetailsUrl={bookingDetailsUrl}
          translations={translations}
          tenantImageUrl={tenantImageUrl}
        />
      </CardContent>
    </Card>
  )
}
